<template>
  <v-card style="height: 800px !important">
    <div class="text-xs-right">
      <v-btn icon flat @click="$emit('closeDetailToggle')">
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <div
      class="nav nav-tabs px-2"
      style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
    >
      <v-btn
        depressed
        class="ma-1"
        :outline="currentTab != 'details'"
        :color="currentTab != 'details' ? 'grey' : 'primary'"
        @click="currentTab = 'details'"
        >ข้อมูลการติดตั้ง</v-btn
      >
      <v-btn
        depressed
        class="ma-1"
        :outline="currentTab != 'history'"
        :color="currentTab != 'history' ? 'grey' : 'primary'"
        @click="currentTab = 'history'"
        >ประวัติการแก้ไขวันนัด</v-btn
      >
    </div>

    <template v-if="currentTab === 'details'">
      <v-card class="px-2" flat>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 class="mb-3">
              <div style="float: right">
                <!-- <v-btn @click="generateReport">test</v-btn>
            <v-btn @click="printProducts" color="primary">
              <v-icon>print</v-icon>&nbsp;
              <span>พิมพ์รายการสินค้าและรูปหน้างาน</span>
            </v-btn> -->

                <v-btn :loading="isLoadingPrint" color="primary" @click="generateReport">
                  <v-icon>print</v-icon>&nbsp;
                  <span>พิมพ์รายการสินค้าและรูปหน้างาน</span>
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs6>
              <div>
                <span>ชื่อ</span>
                <p>{{ detaildata.name }}</p>
              </div>
            </v-flex>
            <v-flex xs6>
              <div>
                <span>Customer ID</span>
                <p>{{ detaildata.customerid }}</p>
              </div>
            </v-flex>
            <v-flex xs6>
              <span>วันติดตั้ง</span>
              <p>
                {{ detaildata.appointmentdate | DateFormat('DD/MM/YYYY') }} ช่วงเวลา
                {{ detaildata.appointmenttime || '-' }}
              </p>
            </v-flex>
            <v-flex xs6>
              <span>คิวที่ใช้</span>
              <p>{{ detaildata.amount || 0 }} คิว</p>
            </v-flex>
            <v-flex xs6>
              <span>เบอร์ติดต่อ</span>
              <p>{{ detaildata.phonenumber }}</p>
            </v-flex>
            <v-flex xs12>
              <span>ที่อยู่</span>
              <p>
                {{ detaildata.address }} {{ `เขต${detaildata.district}` }}
                {{ `แขวง${detaildata.subdistrict}` }} {{ `${detaildata.zipcode}` }}
                {{ `จังหวัด${detaildata.province}` }}
              </p>
            </v-flex>
            <v-flex xs12>
              <v-divider></v-divider>
            </v-flex>
            <v-flex xs6 class="mt-2">
              <span>ชื่อพนักงาน</span>
              <p>{{ detaildata.pcname }}</p>
            </v-flex>
            <v-flex xs6 class="mt-2">
              <span>ร้าน</span>
              <p>{{ detaildata.pclocation }}</p>
            </v-flex>
            <v-flex xs6>
              <span>สาขา</span>
              <p>{{ detaildata.pcbranch }}</p>
            </v-flex>
            <v-flex v-if="detaildata.approveby" xs6>
              <span>Approve by</span>
              <p>{{ detaildata.approveby }}</p>
            </v-flex>
            <v-flex v-if="detaildata.reason" xs6>
              <span>เหตุผลที่ Reject</span>
              <p>{{ detaildata.reason }}</p>
            </v-flex>
          </v-layout>

          <v-btn color="primary" :disabled="!detaildata.googlemap" @click="showMap">
            <v-icon>location_on</v-icon>&nbsp;ดูแผนที่
          </v-btn>
          <div>
            <product-detail-list :productdetails="detaildata.productdetails"></product-detail-list>
          </div>

          <div class="mt-3">
            <span>รูปหน้างาน</span>
            <p v-if="!detaildata.jobsiteimages">-</p>
            <v-menu v-else offset-y attach>
              <template #activator="{ on, attrs }">
                <div class="topic mt-3 mb-3" v-bind="attrs" @click="showMenu = !showMenu" v-on="on">
                  <div style="display: flex; justify-content: space-between">
                    <div>{{ customerImageSelected }}</div>
                    <div>
                      <v-icon>arrow_drop_down_circle</v-icon>
                    </div>
                  </div>
                </div>
              </template>
              <v-list>
                <v-list-tile v-for="(item, index) in customerImageChoice" :key="index">
                  <v-list-tile-title @click="onClickCustomerImageChoice(index)">{{
                    item
                  }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-layout row wrap align-center>
              <v-flex v-for="(img, k) in images" :key="k" xs3 sm3 class="pa-1">
                <v-img aspect-ratio="1" :src="img" @click="openImage(img)">
                  <template #placeholder>
                    <v-layout ma-0 fill-height justify-center align-center>
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-flex>
            </v-layout>
          </div>
          <div>
            <v-divider></v-divider>
          </div>
          <div class="mt-2">
            <v-layout row wrap>
              <v-flex xs6>
                <span>ปัญหาที่พบ</span>
                <p>{{ detaildata.problems || '-' }}</p>
              </v-flex>
              <v-flex xs6>
                <span>หมายเหตุ</span>
                <p>{{ detaildata.note || '-' }}</p>
              </v-flex>
              <v-flex xs6>
                <span>ค่าใช้จ่ายเพิ่มเติม</span>
                <p>{{ detaildata.additionnalcost || '-' }}</p>
              </v-flex>
              <v-flex xs6>
                <span>จำนวนค่าใช้จ่ายเพิ่มเติม</span>
                <p>{{ detaildata.additionnalcostnote || '-' }}</p>
              </v-flex>
              <v-flex xs6>
                <span>วิธีจ่าย</span>
                <p>{{ detaildata.additionnalcostmethod || '-' }}</p>
              </v-flex>
              <v-flex xs6>
                <span>สลิป</span>
                <p>{{ detaildata.additionnalcostreceiptimage || '-' }}</p>
              </v-flex>
            </v-layout>
          </div>
          <div>
            <v-divider></v-divider>
          </div>
          <div v-if="detaildata.beforeinstallhousenoimages" class="pa-2">
            <div style="font-size: 20px">ก่อนติดตั้ง</div>
            <div>
              <span>บ้านเลขที่</span>
              <v-layout row wrap align-center>
                <v-flex
                  v-for="(img, k) in detaildata.beforeinstallhousenoimages"
                  :key="k"
                  xs3
                  sm3
                  class="pa-1"
                >
                  <v-img aspect-ratio="1" :src="img" @click="openImage(img)"></v-img>
                </v-flex>
              </v-layout>
            </div>
            <div>
              <span>กล่องสินค้า</span>
              <v-layout row wrap align-center>
                <v-flex
                  v-for="(img, k) in detaildata.beforeinstallproductimages"
                  :key="k"
                  xs3
                  sm3
                  class="pa-1"
                >
                  <v-img aspect-ratio="1" :src="img" @click="openImage(img)"></v-img>
                </v-flex>
              </v-layout>
            </div>
            <div>
              <span>หน้างานก่อนติดตั้ง</span>
              <v-layout row wrap align-center>
                <v-flex
                  v-for="(img, k) in detaildata.beforeinstalljobsiteimages"
                  :key="k"
                  xs3
                  sm3
                  class="pa-1"
                >
                  <v-img aspect-ratio="1" :src="img" @click="openImage(img)"></v-img>
                </v-flex>
              </v-layout>
            </div>
          </div>
          <v-divider></v-divider>
          <div v-if="detaildata.afterinstallimages" class="pa-2">
            <div style="font-size: 20px">หลังติดตั้ง</div>
            <div>
              <span>งานหลังติดตั้งเสร็จ</span>
              <v-layout row wrap align-center>
                <v-flex
                  v-for="(img, k) in detaildata.afterinstallimages"
                  :key="k"
                  xs3
                  sm3
                  class="pa-1"
                >
                  <v-img aspect-ratio="1" :src="img" @click="openImage(img)"></v-img>
                </v-flex>
              </v-layout>
            </div>
            <div>
              <span>ลูกค้าถือป้าย Checklist</span>
              <v-layout row wrap align-center>
                <v-flex
                  v-for="(img, k) in detaildata.afterinstallcustomerchecklist"
                  :key="k"
                  xs3
                  sm3
                  class="pa-1"
                >
                  <v-img aspect-ratio="1" :src="img" @click="openImage(img)"></v-img>
                </v-flex>
              </v-layout>
            </div>
            <div>
              <span>เอกสาร Check list</span>
              <v-layout row wrap align-center>
                <v-flex
                  v-for="(img, k) in detaildata.afterinstalldocumentchecklist"
                  :key="k"
                  xs3
                  sm3
                  class="pa-1"
                >
                  <v-img aspect-ratio="1" :src="img" @click="openImage(img)"></v-img>
                </v-flex>
              </v-layout>
            </div>
            <div>
              <span>งานเพิ่มเติม (ถ้ามี)</span>
              <v-layout row wrap align-center>
                <v-flex
                  v-for="(img, k) in detaildata.afterinstallother"
                  :key="k"
                  xs3
                  sm3
                  class="pa-1"
                >
                  <v-img aspect-ratio="1" :src="img" @click="openImage(img)"></v-img>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </template>
    <template v-if="currentTab === 'history'">
      <v-card class="px-2" flat>
        <v-card-text>
          <div>
            <v-layout wrap row>
              <v-flex xs3>
                <strong>วันที่ดำเนินการ</strong>
              </v-flex>
              <v-flex xs3>
                <strong>วันที่นัด</strong>
              </v-flex>
              <v-flex xs3>
                <strong>ผู้ดำเนินการ</strong>
              </v-flex>
              <v-flex xs3>
                <strong>ตำแหน่ง</strong>
              </v-flex>
            </v-layout>

            <template
              v-if="detaildata.appointment_history && detaildata.appointment_history.length > 0"
            >
              <v-layout
                v-for="(val, index) in detaildata.appointment_history"
                :key="index"
                wrap
                row
              >
                <v-flex xs3>{{ val.timestamp | DateFormat('DD/MM/YYYY') }}</v-flex>
                <v-flex xs3>{{ val.date | DateFormat('DD/MM/YYYY') }}</v-flex>
                <v-flex xs3>{{ val.account }}</v-flex>
                <v-flex xs3>{{ val.account_role || '-' }}</v-flex>
              </v-layout>
            </template>
            <template v-else>
              <v-layout wrap row>
                <v-flex xs3>{{ detaildata.timestamp | DateFormat('DD/MM/YYYY') }}</v-flex>
                <v-flex xs3>{{ detaildata.appointmentdate | DateFormat('DD/MM/YYYY') }}</v-flex>
                <v-flex xs3>-</v-flex>
                <v-flex xs3>-</v-flex>
              </v-layout>
            </template>
          </div>
        </v-card-text>
      </v-card>
    </template>

    <!-- @beforeDownload="beforeDownload($event)" -->
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1100"
      :html-to-pdf-options="htmlToPdfOptions"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="700px"
      @hasDownloaded="isLoadingPrint = false"
    >
      <section slot="pdf-content">
        <!-- <div>test</div> -->
        <PrintContentDetail :data="detaildata"></PrintContentDetail>
      </section>
    </vue-html2pdf>
  </v-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import ProductDetailList from './ProductDetailList.vue'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from '@/assets/fonts/vfs_fonts.js'
import VueHtml2pdf from 'vue-html2pdf'
import PrintContentDetail from './PrintContentDetail.vue'

pdfMake.vfs = pdfFonts.pdfMake.vfs
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  }
}

export default {
  components: {
    Multiselect,
    ProductDetailList,
    VueHtml2pdf,
    PrintContentDetail
  },
  props: ['detaildata'],
  data() {
    return {
      startDate: '2021-08-06',
      openStartDate: false,
      customerImageSelected: '',
      customerImageChoice: [
        'ภาพโดยรวม',
        // 'ด้านหน้า ระยะห่างระหว่างท่อกับเสา',
        // 'ด้านขวา',
        'ตำแหน่งท่อน้ำทิ้งและน้ำดี ความสูงของพื้น และระยะห่างจากผนัง'
        // 'ขนาดของเสา ด้านซ้าย และขวา',
        // 'ขนาดและตำแหน่งของหน้าต่าง',
        // 'ตำแหน่งของปลั๊กไฟและประตู',
        // 'ความสูงของบัวจากพื้น',
        // 'ความสูงของพื้นถึงด้านบนฝ้า'
      ],
      images: [],
      showMenu: false,
      isLoadingPrint: false,
      currentTab: 'details'
    }
  },
  computed: {
    htmlToPdfOptions() {
      return {
        margin: 5,
        filename: 'ข้อมูลการติดตั้ง',
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          scale: 2,
          allowTaint: true,
          useCORS: true,
          logging: true,
          letterRendering: true
        },
        image: {
          type: 'jpeg',
          quality: 0.98
        },
        pagebreak: {
          mode: 'avoid-all',
          before: '#page2el'
        }
      }
    }
  },
  mounted() {
    this.customerImageSelected = this.customerImageChoice[0]
    this.images = this.detaildata.jobsiteimages ? this.detaildata.jobsiteimages.left : []
  },
  methods: {
    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages()

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i)
            pdf.setFontSize(10)
            pdf.setTextColor(150)
            pdf.text(
              'Page ' + i + ' of ' + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            )
          }
        })
        .save()
    },
    onClickCustomerImageChoice(index) {
      this.customerImageSelected = this.customerImageChoice[index]
      if (!this.detaildata.jobsiteimages) {
        return
      }
      if (index == 0) {
        this.images = this.detaildata.jobsiteimages.left
      } else if (index == 1) {
        this.images = this.detaildata.jobsiteimages.front
      } else if (index == 2) {
        this.images = this.detaildata.jobsiteimages.right
      } else if (index == 3) {
        this.images = this.detaildata.jobsiteimages.sewer
      } else if (index == 4) {
        this.images = this.detaildata.jobsiteimages.pile
      } else if (index == 5) {
        this.images = this.detaildata.jobsiteimages.window
      } else if (index == 6) {
        this.images = this.detaildata.jobsiteimages.plug
      } else if (index == 7) {
        this.images = this.detaildata.jobsiteimages.lotus
      } else {
        this.images = this.detaildata.jobsiteimages.pellicle
      }
    },
    openImage(url) {
      window.open(url, '_blank')
    },
    showMap() {
      var coord = JSON.parse(this.detaildata.googlemap)
      if (coord) {
        var url = `https://maps.google.com/?q=${coord.lat},${coord.lng}`
        window.open(url, '_blank')
      }
    },
    async printProducts() {
      let products = this.detaildata.productdetails
      let productDetail = products.map((p, index) => {
        let productName = { text: index + 1 + '. ' + p.product }
        let photos = !(p.photos && p.photos.length > 0)
          ? ''
          : p.photos.map(async (ps) => {
              return {
                image: this.simpleImageBase64,
                height: 200,
                width: 200,
                margin: [0, 0, 0, 10]
              }
            })
        let format = p.format ? { text: 'รูปแบบการติดตั้ง: ' + p.format } : ''
        let sink = { text: 'ซิงค์: ' + p.sink }
        let drillSink
        if (p.HasDrillSink) {
          drillSink = [
            {
              text:
                'เจาะซิงค์ ' +
                (p.hasOwnProperty('drilSinkOption') ? '(' + p.drilSinkOption + ')' : '')
            }
          ]

          // p.simplePhotoDrillSink.forEach(async pds => {
          //   drillSink.push({
          //     image: this.simpleImageBase64,
          //     height: 200,
          //     width: 200,
          //     margin: [0, 0, 0, 10]
          //   })
          // })
        }

        let drillStove
        if (p.HasDrillStove) {
          drillStove = [
            {
              text:
                'เจาะเตา ' +
                (p.hasOwnProperty('drilStoveOption') ? '(' + p.drilStoveOption + ')' : '')
            }
          ]

          // p.simplePhotoDrillStove.forEach(async pds => {
          //   drillStove.push({
          //     image: this.simpleImageBase64,
          //     height: 200,
          //     width: 200,
          //     margin: [0, 0, 0, 10]
          //   })
          // })
        }

        let other = { text: 'อุปกรณ์อื่นๆ: ' + p.other }
        let remark = { text: 'หมายเหตุ: ' + p.remark, margin: [0, 0, 0, 10] }

        let productFormat = []
        productFormat.push(productName)

        // if (photos) {
        //   productFormat.push(...photos)
        // }

        if (format) {
          productFormat.push(format)
        }

        productFormat.push(sink)
        if (drillSink) {
          productFormat.push(...drillSink)
        }

        if (drillStove) {
          productFormat.push(...drillStove)
        }

        productFormat.push(other)
        productFormat.push(remark)

        return productFormat
      })

      console.log(productDetail)

      let documentFormat = [
        { text: 'ชื่อลูกค้า : ' + this.detaildata.name, style: 'header' },
        { text: 'เบอร์ติดต่อ : ' + this.detaildata.phonenumber, style: 'header' },
        { text: 'PC : ' + this.detaildata.pcname, style: 'header' },
        { text: 'รายการสินค้า', style: ['textBold', 'topicText'], margin: [0, 0, 0, 20] }
      ]

      documentFormat.push(...productDetail)

      // Job site images
      // let sitesImage = []
      // let jobsiteimages = this.detaildata.jobsiteimages

      // if (jobsiteimages) {
      //   if (jobsiteimages.hasOwnProperty('left')) {
      //     let photoType = [
      //       'left',
      //       'front',
      //       'right',
      //       'sewer',
      //       'pile',
      //       'window',
      //       'plug',
      //       'lotus',
      //       'pellicle'
      //     ]
      //     photoType.forEach(pt => {
      //       if (jobsiteimages[pt] && jobsiteimages[pt].length > 0) {
      //         let topicName
      //         if (pt == 'left') {
      //           topicName = 'ภาพโดยรวมด้านซ้าย'
      //         } else if (pt == 'front') {
      //           topicName = 'ด้านหน้า ระยะห่างระหว่างท่อกับเสา'
      //         } else if (pt == 'right') {
      //           topicName = 'ด้านขวา'
      //         } else if (pt == 'sewer') {
      //           topicName = ' ตำแหน่งท่อน้ำทิ้งและน้ำดี ความสูงของพื้น และระยะห่างจากผนัง'
      //         } else if (pt == 'pile') {
      //           topicName = 'ขนาดของเสา ด้านซ้าย และขวา'
      //         } else if (pt == 'window') {
      //           topicName = 'ขนาดและตำแหน่งของหน้าต่าง'
      //         } else if (pt == 'plug') {
      //           topicName = 'ตำแหน่งของปลั๊กไฟและประตู'
      //         } else if (pt == 'lotus') {
      //           topicName = 'ความสูงของบัวจากพื้น'
      //         } else {
      //           topicName = 'ความสูงของพื้นถึงด้านบนฝ้า'
      //         }

      //         sitesImage.push({
      //           text: topicName,
      //           style: 'textBold',
      //           margin: [0, 0, 0, 10]
      //         })

      //         let photos = jobsiteimages[pt].map(async p => {
      //           return {
      //             image: this.simpleImageBase64,
      //             height: 200,
      //             width: 200,
      //             margin: [0, 0, 0, 10]
      //           }
      //         })

      //         sitesImage.push(...photos)
      //       }
      //     })
      //   }
      // }

      // if (sitesImage && sitesImage.length > 0) {
      //   documentFormat.push(...sitesImage)
      // }
    },
    printPDF(documentFormat) {
      const documentPayload = {
        content: [documentFormat],
        styles: {
          header: {
            alignment: 'right',
            color: 'gray'
          },
          textBold: {
            bold: true
          },
          topicText: {
            fontSize: 18
          }
        },
        defaultStyle: {
          font: 'THSarabunNew',
          fontSize: 14
        }
      }
      pdfMake.createPdf(documentPayload).open()
    },
    async getBase64ImageFromURL(url) {
      let blob = await fetch(url).then((r) => r.blob())
      let dataUrl = await new Promise((resolve) => {
        let reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
      return dataUrl
    },
    async encodeToBase64(files) {
      var attach = []
      var reader = []

      // loop through each of the files in q-uploader
      for (let i = 0; i < files.length; i++) {
        attach[i] = await this.singleFileToBase64(i, files, reader)
      }
      // returns an array of all the files in base64 format
      return attach
    },

    singleFileToBase64(i, files, reader) {
      reader[i] = new FileReader()
      // read the file into a base64 format
      reader[i].readAsDataURL(files[i])

      return new Promise((resolve, reject) => {
        reader[i].onerror = () => {
          reader[i].abort()
          reject('Insert error message here')
        }

        // return the base 64 string
        reader[i].onload = function () {
          resolve(reader[i].result)
        }
      })
    },

    generateReport() {
      this.isLoadingPrint = true
      this.$refs.html2Pdf.generatePdf()
    },
    test(val) {
      // alert(status)
      // this.isLoadingPrint = status;
      console.log('Val: ', val)
    }
  }
}
</script>

<style scoped>
.topic {
  padding: 10px 10px 10px 20px;
  background: #dadada;
  color: black;
  width: 100%;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/adminMenu/Detaildialog.vue